import React, { useEffect, useState } from "react";
import FormInput from "../Common/FormInput";
import CommonButton from "../Common/Button";
import { Col, FormGroup, Modal, ModalBody } from "reactstrap";
import FlexCol from "../Common/FlexCol";
import { useFormik } from "formik";
import * as Yup from "yup";
import API, { action } from "../../Api";
import DateSelect from "../Common/DateSelector";
import { notification } from "antd"; // Import Ant Design notification
import DropdownButton from "../Common/DropdownButton";
import CattleImageUpload from "../Common/CattleImageUpload";
import TextArea from "../Common/TextArea";
import { IoMdClose } from "react-icons/io";

function Basicinformation({
  isOpen,
  toggle,
  details,
  Selected,
  getCattleList,
  cattleList,
}) {
  const [cattleType, setCattleType] = useState([]);
  const [maleData, setMaleData] = useState([]);
  const [femaleData, setFemaleData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isGenderDisabled, setIsGenderDisabled] = useState(false);
  const [cattleDetails, setCattleDetails] = useState([]);
  const [image, setImage] = useState("");
  const [restrictedTypes, setRestrictedTypes] = useState([]);
  const [originalCattleTypeLabel, setOriginalCattleTypeLabel] = useState("");
  const [motherDisplayValue, setMotherDisplayValue] = useState("");
  const [fatherDisplayValue, setFatherDisplayValue] = useState("");
  // console.log(image, "image");

  // console.log(cattleType, "details");
  // console.log(details, "nbb");

  const gender = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];
  const getcattleDetails = async (id) => {
    try {
      const result = await action(API.GET_CATTLE_DETAILS, {
        id: id || details.id,
      });

      if (result.response && result.response.data) {
        setCattleDetails(result.response.data);
        console.log(result.response.data, "result.response.data");
      }
    } catch (error) {
      console.error("Error fetching cattle details:", error);
    }
  };

  useEffect(() => {
    if (details && details.id) {
      getcattleDetails(details.id);
    }
  }, [details, isOpen]); // Added isOpen dependency to refresh when modal opens

  // console.log(cattleDetails, "deatai");

  // Helper: get cattle type label from value
  const getCattleTypeLabelByValue = (value) => {
    const found = cattleType.find((type) => type.value === value);
    return found ? found.label : "";
  };

  // Helper: get cattle type value from label
  const getCattleTypeValueByLabel = (label) => {
    const found = cattleType.find(
      (type) => type.label && type.label.toLowerCase() === label.toLowerCase()
    );
    return found ? found.value : "";
  };

  // Restriction logic
  // Returns an array of cattle type values that are NOT allowed to be selected
  const getRestrictedCattleTypeValues = (currentLabel) => {
    // All labels to lower for comparison
    const label = currentLabel ? currentLabel.toLowerCase() : "";
    // Find values for each type
    const cowValue = getCattleTypeValueByLabel("Cow");
    const bullValue = getCattleTypeValueByLabel("Bull");
    const heiferValue = getCattleTypeValueByLabel("Heifer");
    const calfValue = getCattleTypeValueByLabel("Calf");

    // Restriction rules:
    // * Cow: cannot change to Bull, Calf, or Heifer
    // * Bull: cannot change to Cow, Calf, or Heifer
    // * Heifer: cannot change to Calf or Bull
    // * Calf: no restriction (can change to any)
    if (label === "cow") {
      return [bullValue, calfValue, heiferValue].filter(Boolean);
    }
    if (label === "bull") {
      return [cowValue, calfValue, heiferValue].filter(Boolean);
    }
    if (label === "heifer") {
      return [calfValue, bullValue].filter(Boolean);
    }
    // Calf or others: no restriction
    return [];
  };

  // Save the original cattle type label for restriction logic
  useEffect(() => {
    if (cattleDetails && cattleDetails.CattleType?.cattle_type_name) {
      setOriginalCattleTypeLabel(cattleDetails.CattleType.cattle_type_name);
    }
  }, [cattleDetails]);

  // Update restricted types when cattleType or originalCattleTypeLabel changes
  useEffect(() => {
    setRestrictedTypes(getRestrictedCattleTypeValues(originalCattleTypeLabel));
  }, [cattleType, originalCattleTypeLabel]);

  const formik = useFormik({
    initialValues: {
      id: cattleDetails.id,
      cattleType: "",
      dob: "",
      gender: "",
      weight: "",
      father: "",
      mother: "",
      cooperationNumber: "",
      licenceInformation: "",
      notes: "",
      lactation: "",
      expectedDailyMilking: "",
    },
    validationSchema: Yup.object({
      cattleType: Yup.string().required("Required"),
      weight: Yup.number()
        .required("Weight is required")
        .min(1, "Weight must be at least 1")
        .max(9999, "Weight cannot exceed 9999"),
    }),
    onSubmit: async (values) => {
      // Restriction check before submit
      if (
        restrictedTypes.length > 0 &&
        restrictedTypes.includes(values.cattleType)
      ) {
        notification.error({
          message:
            "Changing cattle type to the selected type is not allowed as per system rules.",
          placement: "top",
        });
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        // Fix: If father is empty string or null, send null to API
        const payload = {
          id: cattleDetails.id,
          cattle_type: values.cattleType,
          dob: values.dob,
          gender: values.gender,
          weight: values.weight,
          father:
            values.father === "" || values.father === undefined
              ? null
              : values.father,
          mother: values.mother,
          licence_info: values.licenceInformation,
          corporation_no: values.cooperationNumber,
          image: image,
          notes: values.notes,
          parity_lactation: values.lactation,
          exp_daily_milk: values.expectedDailyMilking,
        };

        const result = await action(API.UPDATE_CATTLE, payload);

        if (result.status.code === 200) {
          notification.success({
            message: "Cattle updated successfully",
            placement: "top",
          });
          getCattleList();
          // Refresh the cattle details to update the image in sidebar
          if (cattleDetails?.id) {
            await getcattleDetails(cattleDetails.id);
            // The image state will be updated automatically via the useEffect
            // that watches cattleDetails changes (lines 240-306)
          }

          toggle();
        } else {
          notification.error({
            message: "Failed to update cattle",
            placement: "top",
          });
        }
      } catch (error) {
        console.error("Error updating cattle:", error);
        // Custom error handling for weight out of range
        const errorMsg = error.response?.data?.response?.message || "";
        if (
          errorMsg &&
          errorMsg
            .toLowerCase()
            .includes("out of range value for column 'weight'")
        ) {
          notification.error({
            message: "Please enter a valid weight value.",
            placement: "top",
          });
        }
        // else {
        //   notification.error({
        //     message: errorMsg || "An error occurred while updating cattle.",
        //     placement: "top",
        //   });
        // }
      } finally {
        setLoading(false); // Stop loading
      }
    },
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
      setMotherDisplayValue("");
      setFatherDisplayValue("");
      // Don't reset image state when modal closes to maintain consistency
      // The image state will be updated when cattleDetails changes
    }
  }, [isOpen]);

  useEffect(() => {
    if (cattleDetails) {
      const selectedCattleType =
        cattleType.find(
          (type) => type.label === cattleDetails.CattleType?.cattle_type_name
        )?.value || "";
      // console.log(selectedCattleType, "selectedCattleType");

      formik.setFieldValue("cattleType", selectedCattleType);
      formik.setFieldValue("dob", cattleDetails.dob || "");
      formik.setFieldValue("gender", cattleDetails.gender || "");
      formik.setFieldValue("weight", cattleDetails.weight || "");
      formik.setFieldValue("father", cattleDetails.father || "");
      // Store mother's ID for API submission
      formik.setFieldValue("mother", cattleDetails.mother || "");
      formik.setFieldValue("lactation", cattleDetails.lactation || "");
      formik.setFieldValue("expectedDailyMilking", cattleDetails.exp_daily_milk || "");

      // Set father display value for UI
      if (cattleDetails.father && maleData.length > 0) {
        const fatherOption = maleData.find(
          (option) => option.value === cattleDetails.father
        );
        if (fatherOption) {
          setFatherDisplayValue(fatherOption.label);
        } else if (cattleDetails.Father?.cattle_id) {
          setFatherDisplayValue(cattleDetails.Father.cattle_id);
        } else {
          setFatherDisplayValue("");
        }
      } else if (cattleDetails.Father?.cattle_id) {
        setFatherDisplayValue(cattleDetails.Father.cattle_id);
      } else {
        setFatherDisplayValue("");
      }

      // Set mother display value for UI
      if (cattleDetails.mother && femaleData.length > 0) {
        const motherOption = femaleData.find(
          (option) => option.value === cattleDetails.mother
        );
        if (motherOption) {
          setMotherDisplayValue(motherOption.label);
        } else if (cattleDetails.Mother?.cattle_id) {
          setMotherDisplayValue(cattleDetails.Mother.cattle_id);
        } else {
          setMotherDisplayValue("");
        }
      } else if (cattleDetails.Mother?.cattle_id) {
        setMotherDisplayValue(cattleDetails.Mother.cattle_id);
      } else {
        setMotherDisplayValue("");
      }

      formik.setFieldValue(
        "licenceInformation",
        cattleDetails.licence_info || ""
      );
      formik.setFieldValue(
        "cooperationNumber",
        cattleDetails.corporation_no || ""
      );
      formik.setFieldValue("cattle_id", cattleDetails.cattle_id || "");
      formik.setFieldValue("notes", cattleDetails.notes || "");
      // Only update image state if it's different to avoid unnecessary re-renders
      if (cattleDetails.image !== image) {
        setImage(cattleDetails.image || "");
      }
    }
  }, [details, cattleDetails, cattleType]);

  const getcattleType = async () => {
    try {
      const result = await action(API.GET_CATTLETYPE);
      const roles = result.response.data.map((role) => ({
        label: role.cattle_type_name,
        value: role.id,
      }));
      setCattleType(roles);
    } catch (error) {
      console.error("Error fetching cattletype data:", error);
    }
  };

  useEffect(() => {
    getcattleType();
  }, []);

  const getMalecattleType = async (searchKey = "") => {
    try {
      const result = await action(API.GET_CATTLE_FILTER_GENDER_ALL, {
        type: 1,
        searchKey: searchKey,
        page: 1,
        pageCount: 60,
      });
      const cattleID = result.response.data
        .filter((cattle) => cattle.id !== details.id)
        .map((id) => ({
          label: id.cattle_id, // Display name
          value: id.id, // Unique identifier
        }));
      setMaleData(cattleID);
    } catch (error) {
      console.error("Error fetching cattletype data:", error);
    }
  };

  const getFemalecattleType = async (searchKey = "") => {
    try {
      const result = await action(API.GET_CATTLE_FILTER_GENDER_ALL, {
        type: 2,
        searchKey: searchKey,
        page: 1,
        pageCount: 60,
      });
      console.log(result, "result");
      const cattleID = result.response.data
        .filter((cattle) => cattle.id !== details.id)
        .map((id) => ({
          label: id.cattle_id, // Display name
          value: id.id, // Unique identifier
        }));

      setFemaleData(cattleID);
      // console.log(femaleData, "cattleID");
    } catch (error) {
      console.error("Error fetching cattletype data:", error);
    }
  };

  useEffect(() => {
    getMalecattleType();
    getFemalecattleType();
  }, [details?.id]);

  useEffect(() => {
    // Check if selected cattle type should force female gender
    const selectedType = cattleType.find(
      (type) => type.value === formik.values.cattleType
    );
    if (selectedType && selectedType.label.toLowerCase() === "cow") {
      formik.setFieldValue("gender", "female");
      setIsGenderDisabled(true);
    } else if (selectedType && selectedType.label.toLowerCase() === "bull") {
      formik.setFieldValue("gender", "male");
      setIsGenderDisabled(true);
    } else if (selectedType && selectedType.label.toLowerCase() === "heifer") {
      formik.setFieldValue("gender", "female");
      setIsGenderDisabled(true);
    } else {
      setIsGenderDisabled(false);
    }
  }, [formik.values.cattleType, cattleType]);

  const handleImageUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await action(API.ADD_CATTLE_IMAGE, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.response.file_name) {
        setImage(response.response.file_name);
        notification.success({
          message: "Image uploaded successfully",
          placement: "top",
        });
      } else {
        notification.error({
          message: "Failed to upload image",
          placement: "top",
        });
      }
    } catch (error) {
      notification.error({
        message:
          error.response?.data?.response?.message || "Error uploading image",
        placement: "top",
      });
    }
  };

  const handleImageDelete = () => {
    setImage("");
    notification.success({
      message: "Image removed successfully",
      placement: "top",
    });
  };

  // Handler for cattle type selection with restriction
  const handleCattleTypeClick = (type) => {
    // If this type is restricted, do nothing and show error
    if (restrictedTypes.includes(type.value)) {
      notification.error({
        message:
          "Changing cattle type to the selected type is not allowed as per system rules.",
        placement: "top",
      });
      return;
    }
    formik.setFieldValue("cattleType", type.value);
  };
  console.log(formik.values, "formik.values");

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <button
          type="button"
          onClick={toggle}
          aria-label="Close"
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            zIndex: 1001,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IoMdClose size={18} color="#333" />
        </button>
        <div className="p-[40px]">
          <div>
            <div className="text-[16px] font-semibold 2xl:text-2xl text-[#09090B] leading-[21.6px] break-words font-plus-jakarta-sans">
              Basic Information
            </div>
            <div className="text-[10px] 2xl:text-sm text-[#726C6C] font-plus-jakarta-sans">
              Enter cattle details to get started.
            </div>
          </div>
        </div>

        <ModalBody>
          <form onSubmit={formik.handleSubmit}>
            <FormGroup className="px-[32px]">
              <FlexCol gap={32}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center gap-y-[40px]">
                  <CattleImageUpload
                    onImageUpload={handleImageUpload}
                    onImageDelete={handleImageDelete}
                    existingImage={image}
                  />
                  <FormInput
                    title="Cattle ID"
                    placeholder="Enter Cattle ID"
                    value={formik.values.cattle_id}
                    change={(e) => formik.setFieldValue("cattle_id", e)}
                    disabled={true}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center">
                  <div className="text-[#16A34A] text-[16px] md:text-[12px] 2xl:text-[16px] font-medium leading-[19.2px] break-words font-plus-jakarta-sans">
                    Cattle Type
                    <div className="flex gap-3 mt-2">
                      {cattleType.map((type) => {
                        const isRestricted = restrictedTypes.includes(
                          type.value
                        );
                        return (
                          <div
                            key={type.value}
                            onClick={
                              isRestricted
                                ? undefined
                                : () => handleCattleTypeClick(type)
                            }
                            className={`p-2 rounded-lg cursor-pointer ${
                              formik.values.cattleType === type.value
                                ? "bg-[#E3E3E3]"
                                : "bg-transparent"
                            } flex justify-center items-center ${
                              isRestricted
                                ? "opacity-50 pointer-events-none"
                                : ""
                            }`}
                            style={
                              isRestricted
                                ? { cursor: "not-allowed", userSelect: "none" }
                                : {}
                            }
                            title={
                              isRestricted
                                ? "Changing to this cattle type is not allowed"
                                : ""
                            }
                          >
                            <div className="text-[#0A0B0A] text-[12px] md:text-[10px] font-medium leading-[16.8px] break-words font-plus-jakarta-sans">
                              {type.label}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <DateSelect
                    title="Date of Birth"
                    placeholder="Choose Date of Birth"
                    value={formik.values.dob}
                    change={(e) => formik.setFieldValue("dob", e)}
                    disabledFutureDate={true}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center">
                  <DropdownButton
                    title="Gender"
                    placeholder="Select Gender"
                    options={gender}
                    value={formik.values.gender}
                    change={(e) => formik.setFieldValue("gender", e)}
                    disabled={isGenderDisabled}
                    SelectName="Select Gender"
                  />

                  <FormInput
                    type="number"
                    title="Weight"
                    placeholder="Enter Weight"
                    value={formik.values.weight}
                    change={(e) => {
                      // Only allow up to 4 digits
                      let val = e;
                      // If e is an event, get value from event.target.value
                      if (e && e.target) val = e.target.value;
                      // Remove non-digits and limit to 4 digits
                      val = val.replace(/\D/g, "").slice(0, 4);
                      formik.setFieldValue("weight", val);
                    }}
                    maxLength={4}
                    inputProps={{ maxLength: 4 }}
                    required={true}
                    error={formik.touched.weight && formik.errors.weight}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center">
                  {" "}
                  <DropdownButton
                    title="Fathered By"
                    placeholder="Search Father..."
                    value={fatherDisplayValue}
                    options={maleData}
                    change={(e) => {
                      if (e === undefined || e === null) {
                        // Handle clear action
                        formik.setFieldValue("father", null);
                        setFatherDisplayValue("");
                      } else {
                        // When a selection is made, find the corresponding option to get the display label
                        const selectedOption = maleData.find(
                          (option) => option.value === e
                        );
                        formik.setFieldValue("father", e);
                        setFatherDisplayValue(selectedOption?.label || "");
                      }
                    }}
                    onSearch={(search) => getMalecattleType(search)}
                    SelectName="Select Father"
                    showSearch
                  />
                  <DropdownButton
                    title="Mothered By"
                    placeholder="Select Mother"
                    value={motherDisplayValue}
                    options={femaleData}
                    change={(e) => {
                      if (e === undefined || e === null) {
                        // Handle clear action
                        formik.setFieldValue("mother", "");
                        setMotherDisplayValue("");
                      } else {
                        // When a selection is made, find the corresponding option to get the display label
                        const selectedOption = femaleData.find(
                          (option) => option.value === e
                        );
                        formik.setFieldValue("mother", e);
                        setMotherDisplayValue(selectedOption?.label || "");
                      }
                    }}
                    onSearch={(search) => getFemalecattleType(search)}
                    SelectName="Select Mother"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center">
                  {" "}
                  <FormInput
                    title="License Information"
                    placeholder="Enter License Information"
                    value={formik.values.licenceInformation}
                    change={(e) =>
                      formik.setFieldValue("licenceInformation", e)
                    }
                  />
                  <FormInput
                    title="Cooperation Number"
                    placeholder="Enter Cooperation Number"
                    value={formik.values.cooperationNumber}
                    change={(e) => formik.setFieldValue("cooperationNumber", e)}
                  />
                </div>


                {/* Conditional fields for Cow and Heifer */}
                {(formik.values.cattleType &&
                  cattleType.find(type => type.value === formik.values.cattleType)?.label?.toLowerCase() === "cow" ||
                  cattleType.find(type => type.value === formik.values.cattleType)?.label?.toLowerCase() === "heifer"
                ) && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center">
                    <FormInput
                      type="number"
                      title="Number of Parity/Lactation"
                      placeholder="Enter Current Lactation"
                      value={formik.values.lactation}
                      change={(e) => {
                        let val = e;
                        if (e && e.target) val = e.target.value;
                        val = val.replace(/\D/g, "").slice(0, 3);
                        formik.setFieldValue("lactation", val);
                      }}
                      maxLength={3}
                      inputProps={{ maxLength: 3 }}
                    />
                    <FormInput
                      type="number"
                      title="Expected Daily Milking"
                      placeholder="Enter Expected Daily Milking"
                      value={formik.values.expectedDailyMilking}
                      change={(e) => {
                        let val = e;
                        if (e && e.target) val = e.target.value;
                        val = val.replace(/\D/g, "").slice(0, 4);
                        formik.setFieldValue("expectedDailyMilking", val);
                      }}
                      maxLength={4}
                      inputProps={{ maxLength: 4 }}
                    />
                  </div>
                )}

                <div className="grid grid-cols-1 gap-[30px] items-center">
                  {/* <FormInput
                    title="Additional Notes"
                    placeholder="Enter Additional Notes"
                    value={formik.values.notes}
                    change={(e) => formik.setFieldValue("notes", e)}
                  /> */}
                  <TextArea
                    title="Additional Notes"
                    placeholder="Write any additional notes here..."
                    value={formik.values.notes}
                    change={(e) => formik.setFieldValue("notes", e)}
                    error={formik.touched.notes && formik.errors.notes}
                  />
                </div>

                <Col className="flex justify-end mt-5 gap-2">
                  <CommonButton title="Save" type="submit" disabled={loading} />
                  <CommonButton
                    title="Cancel"
                    type="button"
                    onClick={toggle}
                    disabled={loading}
                  />
                </Col>
              </FlexCol>
            </FormGroup>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default Basicinformation;
